export default __webpack_public_path__ + "static/PHIL_ENDE_BW_web-8ae9ca67b0d88c5f28175de13778211f.jpg";